export default __webpack_public_path__ + "static/media/peripheral3.9d6b7a7e.jpg";